import { Trip } from '../../models/Trip/Trip.model';

export class AddTrips {
  static readonly type = '[TRIPS] add';
  constructor(public payload: Trip[]) {}
}

export class RemoveTrips {
  static readonly type = '[TRIPS] remove';
  constructor() {
    /**/
  }
}
